import { connect } from 'react-redux';

const mapStateToProps = state => ({
  breadcrumbs: state.mainreducer.breadcrumbs,
});

export default BreadCrumbs => connect(mapStateToProps, null)(BreadCrumbs);
